import initializeApp, { Params } from 'Jsx/Shared/LayoutV2/initializeApp';

import App, { AppProps } from './App';
import locales from './i18n';
import { initialStatePageKey, SEARCH_LANDING_PAGE_KEY } from './constants';

const appConfig: Params<AppProps> = {
  App,
  initialStatePageKey,
  layoutProps: { withUITheme: true },
  i18nConfig: {
    pageKey: SEARCH_LANDING_PAGE_KEY,
    defaults: locales,
  },
  extraState: {},
};

if (module.hot) {
  module.hot.accept('./App.tsx', function () {
    initializeApp(appConfig);
  });
}

initializeApp(appConfig);
